
import axios from '@/axios.js'

export default {
  fetchPromoCategories ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/promo-category')
        .then(({data: response}) => {
          commit('SET_PROMO_CATEGORIES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchPromoCategory (context, promoCategoryId) {
    return new Promise((resolve, reject) => {
      axios.get(`/promo-category/${promoCategoryId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  storePromoCategory (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/promo-category', payload)
           .then(res => {
             resolve(res)
           })
           .catch(err => {
             reject(err)
           })
    })
  },

  updatePromoCategory (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`/promo-category/${payload.id}`, payload.body)
           .then(res => {
             resolve(res)
           })
           .catch(err => {
             reject(err)
           })
    })
  },

  destroyPromoCategory ({ commit }, promoCategoryId) {
    return new Promise((resolve, reject) => {
      axios.delete(`promo-category/${promoCategoryId}`)
        .then((response) => {
          commit('REMOVE_RECORD', promoCategoryId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
